/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       ReservationGuestImage.tsx
 * @author     Christian Ascone
 * @date       10/24/19 4:28 PM
 */

import React from 'react';
import {Image} from "react-native";

export function ReservationGuestImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/reservation_guest.png')
            }
        />
    );
}